import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

import { brandFocusRing, outlineFieldStyles } from './shared'

const variants = {
  outline: (props: StyleFunctionProps) => ({
    field: {
      ...outlineFieldStyles(props),
      _placeholder: {
        color: mode('gray.400', 'gray.500')(props),
      },
    },
    addon: {
      borderRadius: 'lg',
      bg: mode('gray.50', 'gray.700')(props),
    },
  }),
  'outline-on-accent': () => ({
    field: {
      bg: 'white',
      borderRadius: 'lg',
      color: 'gray.900',
      borderWidth: '1px',
      borderColor: 'brand.50',
      _placeholder: {
        color: 'gray.500',
      },
      _hover: {
        borderColor: 'brand.100',
      },
      _focus: {
        borderColor: 'brand.200',
        boxShadow: '0px 0px 0px 1px var(--chakra-colors-brand-200)',
      },
      _focusVisible: {
        borderColor: 'brand.200',
        boxShadow: '0px 0px 0px 1px var(--chakra-colors-brand-200)',
      },
    },
  }),
  filled: (props: StyleFunctionProps) => {
    if (props.colorScheme === 'gray') {
      return {
        field: {
          bg: mode('white', 'gray.800')(props),
          _hover: {
            borderColor: mode('gray.200', 'gray.700')(props),
            bg: mode('white', 'gray.700')(props),
          },
          _focus: {
            borderColor: 'accent',
            bg: mode('white', 'gray.800')(props),
          },
          _focusVisible: {
            ...brandFocusRing(props),
            borderColor: 'accent',
            bg: mode('white', 'gray.800')(props),
          },
        },
      }
    }
    return {
      field: {
        bg: 'bg-accent-subtle',
        color: 'on-accent',
        _placeholder: {
          color: 'on-accent',
        },
        _hover: {
          borderColor: 'brand.400',
          bg: 'bg-accent-subtle',
        },
        _focus: {
          bg: 'bg-accent-subtle',
          borderColor: 'brand.300',
        },
        _focusVisible: {
          bg: 'bg-accent-subtle',
          borderColor: 'brand.300',
          boxShadow: '0px 0px 0px 1px var(--chakra-colors-brand-300)',
        },
      },
    }
  },
}

const sizes = {
  lg: {
    field: {
      fontSize: 'md',
      borderRadius: 'lg',
    },
  },
}

export default {
  variants,
  sizes,
  defaultProps: {
    colorScheme: 'gray',
  },
}
